export default function GridShape() {
  return (
    <>
      <div className="absolute right-0 top-0 -z-1 w-full max-w-[250px] opacity-30 dark:opacity-20 xl:max-w-[450px]">
        <svg
          width="450"
          height="450"
          viewBox="0 0 450 450"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <pattern id="grid-pattern-1" width="30" height="30" patternUnits="userSpaceOnUse">
              <path d="M 30 0 L 0 0 0 30" fill="none" stroke="currentColor" strokeWidth="0.5" className="text-gray-300 dark:text-gray-700" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid-pattern-1)" />
        </svg>
      </div>
      <div className="absolute bottom-0 left-0 -z-1 w-full max-w-[250px] rotate-180 opacity-30 dark:opacity-20 xl:max-w-[450px]">
        <svg
          width="450"
          height="450"
          viewBox="0 0 450 450"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <pattern id="grid-pattern-2" width="30" height="30" patternUnits="userSpaceOnUse">
              <path d="M 30 0 L 0 0 0 30" fill="none" stroke="currentColor" strokeWidth="0.5" className="text-gray-300 dark:text-gray-700" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid-pattern-2)" />
        </svg>
      </div>
    </>
  );
}
